import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';

export interface GlobalLoadingState {
  isLoading: boolean;
  progressPercent?: number;
}

const initialState: GlobalLoadingState = {
  isLoading: false,
  progressPercent: undefined,
};

export const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    setGlobalLoadingIsLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading;
    },
    setGlobalLoadingProgressPercent: (state, action: PayloadAction<{ progressPercent?: number }>) => {
      state.progressPercent = action.payload.progressPercent;
    },
  },
});

export const { setGlobalLoadingIsLoading, setGlobalLoadingProgressPercent } = globalLoadingSlice.actions;

export const globalLoadingIsLoadingSelector = (state: RootState): boolean => state.globalLoading.isLoading;

export const globalLoadingProgressPercentSelector = (state: RootState): number | undefined =>
  state.globalLoading.progressPercent;

export default globalLoadingSlice.reducer;
